import { useEffect, useState, useRef } from 'react';
import './Portada.css';
import addGclid from './gclid';

function Portada(props) {

  const [smallScreen, setSmallScreen] = useState(window.innerWidth <= 900)

  useEffect(() => {
    window.addEventListener('resize', () => setSmallScreen(window.innerWidth <= 900))
    return () => window.removeEventListener('resize', () => setSmallScreen(window.innerWidth <= 900))
  }, [])

  const [showModal, setShowModal] = useState(false)

  const [nombre, setNombre] = useState('')
  const [telefono, setTelefono] = useState('')
  const [mail, setMail] = useState('')
  const [localidad, setLocalidad] = useState('')

  const submitForm = e => {
    e.preventDefault()
    if (telefono !== '') {
      setShowModal(true)
      const scrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = '-' + scrollY + 'px'

      const infinitFibraForm = {};

      infinitFibraForm.nombre = nombre;
      infinitFibraForm.telefono = telefono;
      infinitFibraForm.mail = mail;
      infinitFibraForm.localidad = localidad;
      infinitFibraForm.origen = '/fibraoptica';
      infinitFibraForm.gclid = addGclid();

      window.enhanced_conversion_data.phone_number = telefono

      const jsonData = JSON.stringify(infinitFibraForm);

      let integromatRequest = new XMLHttpRequest();
      integromatRequest.open('POST', 'https://hook.us1.make.com/t49vtz5fpyqxr5nxdbnn9h1bk2ry1lye');

      integromatRequest.onreadystatechange = function () {
        if (integromatRequest.readyState === 4) {
          if (integromatRequest.status === 200) {
            window.gtag('event', 'conversion', { 'send_to': 'AW-652151810/XLQqCLCp5s0BEIKY_LYC' })
            window.gtag('event', 'leadForm')
            window.fbq('track', 'Lead')
            window.fbq('trackCustom', 'FormularioEnviado', { origen: '/fibraoptica' })
            window.location.replace('/fibraoptica/gracias')
          } else {
            alert("Error al enviar el formulario, por favor vuelva a intentarlo o comuníquese por otra vía.")
          }
          setShowModal(false)
          const scrollY = document.body.style.top;
          document.body.style.position = '';
          document.body.style.top = '';
          window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }
      };
      let newsletterServiceRequest = new XMLHttpRequest();
      newsletterServiceRequest.open('POST', 'https://newsletterservice.com.ar/landing/api/infinitfibra');
      newsletterServiceRequest.setRequestHeader('Content-Type', 'application/json');
      newsletterServiceRequest.send(jsonData);

      integromatRequest.setRequestHeader('Content-Type', 'application/json');
      integromatRequest.send(jsonData);

    } else {
      alert('Por favor, ingrese su número de teléfono antes de enviar el formulario.')
    }
  }

  const inputRef = useRef()

  useEffect(() => {
    if (props.focus !== null) {
      inputRef.current.focus()
    }
  }, [props.focus])

  return (
    <div className="Portada" style={{ backgroundImage: 'url(' + process.env.PUBLIC_URL + (smallScreen ? '/imgs/portada-small.png)' : '/imgs/portada.png)') }}>
      <div className="Portada-imgs">
        <img className="Portada-imgs-promo" src={process.env.PUBLIC_URL + '/imgs/promo.svg'} alt="100MB + Claro video + instalación bonificada desde $11999 mensuales" />
        <img className="Portada-imgs-sub" src={process.env.PUBLIC_URL + '/imgs/promo-sub.svg'} alt="YouTube Spotify Twitch Netflix" />
      </div>
      <form className="Formulario" onSubmit={submitForm}>
        <p><b>Verificá tu cobertura</b><br />completando el formulario</p>
        <input className="Formulario-input" type="text" onChange={e => setNombre(e.target.value)} value={nombre} placeholder="Nombre y apellido"></input>
        <input ref={inputRef} className="Formulario-input" type="tel" onChange={e => setTelefono(e.target.value)} value={telefono} placeholder="Teléfono*"></input>
        <input className="Formulario-input" type="email" onChange={e => setMail(e.target.value)} value={mail} placeholder="Mail"></input>
        <input className="Formulario-input" type="text" onChange={e => setLocalidad(e.target.value)} value={localidad} placeholder="Localidad"></input>
        <input className="Formulario-submit" type="submit" value="¡Verificar!"></input>

        {showModal ?
          <div className="Formulario-modal">
            <img src={process.env.PUBLIC_URL + '/imgs/cargando.gif'} alt="" />
            <p>Enviando el formulario, por favor aguarda</p>
          </div>
          : null}
      </form>
    </div>
  );
}

export default Portada;